<template>
  <div id="seleccionNaveModal">
    <ui-modal
      ref="modal_nave"
      title="Selección de nave"
      @close="actionSetVisibleModalSeleccionNave(false)"
    >
      <loading v-if="loadingData" style="padding: 70px 0" />

      <data-table
        v-else
        numerador
        :headers="cabeceras"
        :data="data"
        :acciones="acciones"
        :seleccionar="obtenerFilaSeleccionada"
        buscar
        idtabla="select_service_add_booking"
        :max="10"
        paginacion
      />
    </ui-modal>
  </div>
 
</template>

<script>
import { mapState, mapActions } from "vuex";

// Keen UI
import UiModal from "keen-ui/lib/UiModal";

// Componentes
import DataTable from "../../../common/DataTable";

// Constantes
import { obtenerNave } from "../../../../constants/lineas";
import Loading from "../../../common/loading";

export default {
  props: {
    year: { Type: Object, default: null },
    week: { Type: Object, default: null },
    pod: { Type: Object, default: null },
    type: { Type: Object, default: null },
  },
  components: { UiModal, DataTable, Loading },
  data() {
    return {
      cabeceras: [
        "Semana",
        "Naviera",
        "Nave",
        "Viaje",
        "POL",
        "POL ETD",
        "POD ETA",
        "Acción",
      ],
      data: [],
      acciones: [],
      year_aux: this.year,
      week_aux: this.week,
      pod_aux: this.pod,
      type_aux: this.type,
      initial_load: true,
      loadingData: false,
    };
  },
  computed: {
    ...mapState("lineas", ["visibleModalSeleccionNave"]),
    ...mapState(["loadingTable"]),
  },
  methods: {
    ...mapActions("lineas", [
      "actionSetDataNaveSeleccionada",
      "actionSetVisibleModalSeleccionNave",
    ]),

    openModal(ref) {
      this.$refs[ref].open();
    },

    closeModal(ref) {
      this.$refs[ref].close();
    },

    async getNavesViajes() {
      let sql = "";

      if (
        Object.keys(this.year).length > 0 &&
        Object.keys(this.week).length > 0 &&
        Object.keys(this.pod).length > 0 &&
        Object.keys(this.type).length > 0
      ) {
        this.loadingData = true;

        sql = await obtenerNave(
          this.year.id,
          this.week.id,
          this.pod.id,
          this.type.type
        );

        this.data = await sql.data_table;

        this.loadingData = false;
        // Llama a la función para generar botones
        this.generarBotonesAcciones();
      }
    },

    async generarBotonesAcciones() {
      let me = this;

      await me.data.map((item, index) => {
        me.acciones.push([
          {
            icon: "far fa-check-circle fa-lg text-success",
            title: "Seleccionar",
            id: index,
            size: 20,
          },
        ]);
      });
    },

    obtenerFilaSeleccionada(fila) {
      this.actionSetDataNaveSeleccionada({
        naviera: this.data[fila.id].data_complementaria.naviera,
        nave: this.data[fila.id].data[2],
        viaje: this.data[fila.id].data[3],
        pol: this.data[fila.id].data_complementaria.puerto_embarque,
        from_date: this.data[fila.id].data[5],
        to_date: this.data[fila.id].data[6],
        itinerary_id: this.data[fila.id].data_complementaria.itinerary_id,
      });

      this.closeModal("modal_nave");
    },
  },

  watch: {
    visibleModalSeleccionNave: function (_new) {
      if (_new) {
        this.openModal("modal_nave");
        this.getNavesViajes();
      }
    },
    // year: function (_new) {
    //   _new && !this.initial_load && this.getNavesViajes();
    // },
    // week: function (_new) {
    //   _new && !this.initial_load && this.getNavesViajes();
    // },
    // pod: function (_new) {
    //   _new && !this.initial_load && this.getNavesViajes();
    // },
    // type: function (_new) {
    //   _new && !this.initial_load && this.getNavesViajes();
    // },
  },
};
</script>

<style>
#seleccionNaveModal .ui-modal__container {
  width: 60% !important;
}

#seleccionNaveModal .ui-focus-container {
  margin-top: 0px !important;
}
</style>
